import React, { useMemo } from "react";
import UnifiedPortfolioGallery from "./UnifiedPortfolioGallery";
import { ProfileData } from "@/hooks/useProfiles";
import { useCaseStudies } from "@/hooks/useCaseStudies";
import EmptyStatePublic from "./EmptyStatePublic";
import { CaseStudyItem } from "@/types/case-study";

interface PortfolioTabProps {
  profile?: ProfileData | null;
  hideTitle?: boolean;
  openPortfolioModal?: any;
  onClosePortfolioModal?: () => void;
  caseStudies?: CaseStudyItem[];
}

const PortfolioTab = ({ profile, hideTitle = false, openPortfolioModal, onClosePortfolioModal, caseStudies: propCaseStudies }: PortfolioTabProps) => {
  const portfolioItems = useMemo(
    () =>
      (profile?.portfolio_items || []).filter(
        (item) => item.status !== "draft"
      ),
    [profile?.portfolio_items]
  );

  // Fetch case studies only if not provided as prop (for backwards compatibility)
  const { data: fetchedCaseStudies = [] } = useCaseStudies(propCaseStudies ? undefined : profile?.id);
  
  // Use provided case studies or fetched ones
  const caseStudies = propCaseStudies || fetchedCaseStudies;

  // Filter published case studies
  const publishedCaseStudies = useMemo(() =>
    caseStudies.filter(cs => cs.status === "published"),
    [caseStudies]
  );

  const hasPortfolioItems = portfolioItems && portfolioItems.length > 0;
  const hasCaseStudies = publishedCaseStudies && publishedCaseStudies.length > 0;
  const hasAnyContent = hasPortfolioItems || hasCaseStudies;

  return (
    <div className="space-y-8">
      {hasAnyContent ? (
        <UnifiedPortfolioGallery
          username={profile?.username || "Designer"}
          username_slug={profile?.username_slug || ""}
          portfolioItems={portfolioItems}
          caseStudies={publishedCaseStudies}
          profile={profile as { 
            id: string;
            avatar_url?: string | null;
            profession?: string | null;
            display_name?: string | null;
          }}
          openPortfolioModal={openPortfolioModal}
          onClosePortfolioModal={onClosePortfolioModal}
        />
      ) : (
        <EmptyStatePublic
          type="portfolio"
          username={profile?.username}
          profileId={profile?.id}
          profile={profile as any}
        />
      )}
    </div>
  );
};

export default PortfolioTab;
